import socket from '@/plugins/socket'
import WonTiedLost from '@/store/model/sport/sport/WonTiedLost'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas.forEach(item => { state.list.push(new WonTiedLost(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportWontiedLost', 'Sport/WonTiedLost/set') }
  },
  getters: {
    list: (state) => state.list
  }
}
